import http, { url } from '../../http'

const API_URL = "accident_investigation"

class researchAPI {

  async save(research) { 
    const response = await http(`${API_URL}/save`, 'POST', research)
    return response
  }

  async getAccidentReport(id) {
    const response = await http(`${API_URL}/report/${id}`)
    return response
  }

  async updateAccident(id, accident) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', accident)
    return response
  }

}

export default new researchAPI()